import { render, staticRenderFns } from "./IdentificationIntroduction.vue?vue&type=template&id=213b8e81&lang=pug&"
import script from "./IdentificationIntroduction.vue?vue&type=script&lang=js&"
export * from "./IdentificationIntroduction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports